import { GlobalServices } from '../../../services/global.service';
import { ssApiService } from '../../../services/ss-api.service';
import { BillingHistoryResponse, BillingHistoryResponseArray } from '../../../models/ss-api/responses/billing.history.response';
import { Component, OnInit } from '@angular/core';
import { HttpError } from 'app/models/errors/HttpError';
import { DecimalPipe } from '@angular/common';

@Component({
    selector: 'account-billing-history-new',
    templateUrl: './billing-history-new.component.html',
    styleUrls: ['./billing-history-new.component.scss'],
    providers: [DecimalPipe]
})
export class BillingHistoryNewComponent implements OnInit {

    // public
    BillingItems: BillingHistoryResponseArray = new BillingHistoryResponseArray();
    Token: string;

    IsBusy: boolean = false;

    billingHistoryResultRows: number = 25;
    firstResult: number = 0;
    lastResult: number = 24;

    ReportURL: string;

    constructor(private api: ssApiService, private gb: GlobalServices, private decimalPipe: DecimalPipe) { }

    ngOnInit() {
        this.Token = this.gb.TokenToUrlFriendly();
        this.ReportURL = this.gb.ReportURL;
        this.Refresh();
    }

    PaidDate(item: BillingHistoryResponse): boolean {

        if (item.DateTimePaid < item.DateTimeCreated)
            return false;
        else
            return true;

    }

    Refresh() {

        this.IsBusy = true;

        let request = this.api.BillingHistory()
            .subscribe(response => {
                request.unsubscribe();

                this.IsBusy = false;

                if (!response.Result)
                    return; // error

                // console.log(response.Data);
                this.BillingItems = this.SortBillingItems(response.Data);

            },


                (error: HttpError) => {
                    request.unsubscribe();
                    this.IsBusy = false;
                }
            );


    }

    InvoiceTotal(invoice: BillingHistoryResponse): string {

        if (invoice.Refunded)
            return '$0 - Refunded';
        else
            return '$' + this.decimalPipe.transform(invoice.Total, '1.2');

    }


    Details(invoice: BillingHistoryResponse): string {

        // here we generate the HTML for the description

        // if we don't have a description show no items
        if (invoice.Items == undefined || invoice.Items.length == 0)
            return '(no items)';

        // prepare description string
        let description = '';

        // loop through all the invoice items
        for (let i = 0; i < invoice.Items.length; i++) {

            // add a break if we are on line 2+
            if (i > 0)
                description += '<br>';

            // define current item for easy read
            let currentItem = invoice.Items[i];

            // add description string
            description += currentItem.Description;

            if (currentItem.Amount > 0) {
                // if we have amount > 0 add it at the end of the description
                description += ' <span class="ammount">$' + this.decimalPipe.transform(currentItem.Amount, '1.2') + '</span>';
            }

        }

        // return the description HTML
        return description;
    }

    SortBillingItems(SortMe: BillingHistoryResponseArray): BillingHistoryResponseArray {
        SortMe.sort((a, b) => {
            let dateA = new Date().getTime();
            if (a.DateTimeCreated != undefined)
                dateA = new Date(a.DateTimeCreated).getTime();

            let dateB = new Date().getTime();
            if (b.DateTimeCreated != undefined)
                dateB = new Date(b.DateTimeCreated).getTime();

            return dateB - dateA;
		});
        return SortMe;
    }

    paginateBillingHistory(e) {
        this.firstResult = e.page * e.rows;
        this.lastResult = this.firstResult + e.rows;
    }

}
